window.CardLegendsSearch = window.CardLegendsSearch || {};

window.CardLegendsSearch.normalizeQuery = (query) => {
  const trimmedQuery = String(query || '').trim().replace(/\s+/g, ' ');
  const exactAliases = new Map([
    ['psa10', 'PSA 10'],
    ['psa-10', 'PSA 10'],
    ['psa 10', 'PSA 10'],
    ['pokmon', 'Pokémon'],
    ['one peice', 'One Piece'],
    ['yugioh', 'Yu-Gi-Oh!'],
  ]);
  const onePieceSetCode = trimmedQuery.match(/^op[\s-]*0?(\d{1,2})$/i);
  const compactSetCode = trimmedQuery.match(/^(st|eb|prb)[\s-]*0?(\d{1,2})$/i);

  if (onePieceSetCode) return `OP-${onePieceSetCode[1].padStart(2, '0')}`;
  if (compactSetCode) return `${compactSetCode[1].toUpperCase()}${compactSetCode[2].padStart(2, '0')}`;

  return exactAliases.get(trimmedQuery.toLocaleLowerCase('de-DE')) || trimmedQuery;
};
